import { SheRavenClient } from './ravenClient';
import { SheEnv } from '../../commonv3/utils/envs';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const gtag: any;

const TIMEOUT = 1000;

export class GoogleOptimizeClient {
  /**
   * Returns the variant id
   * It returns the control group '0' when the Google Optimize doesn't return response in 300ms
   * @param experimentId
   */
  static getVariantId(experimentId: string): Promise<string> {
    /**
     * テスト中は全てのABテストを無効にする
     * 特定のバケットに割り当てたい場合はURLでオーバーライドすること
     */
    if (SheEnv.isTest()) {
      return Promise.resolve('0');
    }
    try {
      if (!gtag) {
        throw new Error("Failed getting variant id: gtag doesn't exist");
      } else {
        return Promise.race<string>([
          new Promise((resolve) => {
            gtag('event', 'optimize.callback', {
              name: experimentId,
              callback: (value: string) => {
                resolve(value);
              },
            });
          }),
          new Promise((resolve) => {
            setTimeout(() => resolve('0'), TIMEOUT);
          }),
        ]);
      }
    } catch (e) {
      SheRavenClient.captureException(e);
      return Promise.resolve('0');
    }
  }
}
